import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const ACTIVE_INDICATOR_WIDTH = "3px";

export const useStyles = makeStyles({
  section: {
    borderBottom: `1px solid ${projectIqTokens.sidebarBorder}`,
    marginBottom: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[2],
    flexShrink: 0,
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    padding: "4px 0",
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[4]}`,
    borderLeft: `${ACTIVE_INDICATOR_WIDTH} solid transparent`,
    borderRadius: 0,
    color: projectIqTokens.sidebarItemText,
    cursor: "pointer",
    userSelect: "none",
    fontSize: "12.5px",
    fontWeight: designTokens.fontWeight.normal,
    ":hover": { backgroundColor: projectIqTokens.sidebarHover },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },
  itemCollapsed: {
    justifyContent: "center",
    paddingLeft: 0,
    paddingRight: 0,
  },
  itemSelected: {
    backgroundColor: projectIqTokens.sidebarActiveBg,
    borderLeft: `${ACTIVE_INDICATOR_WIDTH} solid ${projectIqTokens.teal2}`,
    color: designTokens.neutral.white,
    ":hover": { backgroundColor: projectIqTokens.sidebarActiveBg },
  },
  itemIconSelected: {
    color: projectIqTokens.teal2,
  },
  itemIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  itemLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  skeletonRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[2]}`,
    borderLeft: `${ACTIVE_INDICATOR_WIDTH} solid transparent`,
    borderRadius: designTokens.borderRadius.md,
  },
  skeletonRowCollapsed: {
    justifyContent: "center",
    paddingLeft: 0,
    paddingRight: 0,
  },
  skeletonIcon: {
    width: designTokens.iconSize.sm,
    height: designTokens.iconSize.sm,
    borderRadius: designTokens.borderRadius.full,
    flexShrink: 0,
  },
  skeletonLabel: {
    height: designTokens.iconSize.sm,
    flex: "1 1 0%",
    borderRadius: designTokens.borderRadius.sm,
  },
});
